import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import React from "react";
import SINGLE_SUBNET_CONTEXT from "src/context/internal/subnet";
import { Subheading } from "src/components/base/heading";
import { Text } from "src/components/base/text";
import { Button } from "src/components/base/button";
import { CheckCircleIcon, ServerStackIcon, XCircleIcon } from "@heroicons/react/20/solid";
import { ApiInternal } from "src/api/api_internal";

export const Route = createFileRoute("/_admin/a/subnets/$subnetId/_subnet/routers")({
    component: RouteComponent,
});

/** Admin view of a subnet's current and available routers */
function RouteComponent() {
    const [t] = useTranslation("admin-subnet-routers");

    const { subnet, reset } = React.useContext(SINGLE_SUBNET_CONTEXT);
    const routers_available = subnet.possible_routers
        .filter(({ approved }) => !approved)
        .sort((a, b) => a.device.dnsname.localeCompare(b.device.dnsname));

    return (
        <>
            <Subheading className={"mb-2"}>{t("heading.current-routers")}</Subheading>
            {subnet.routers.length === 0 && <Text>{t("description.no-current-routers")}</Text>}
            <div className={"flex flex-col gap-1"}>
                {subnet.routers
                    .sort((a, b) => a.dnsname.localeCompare(b.dnsname))
                    .map((device) => (
                        <div className={"flex max-w-md gap-1"}>
                            <Button
                                outline
                                className={"grow justify-start!"}
                                href={"/a/devices/$deviceId/general"}
                                params={{ deviceId: device.uuid }}
                            >
                                <ServerStackIcon className={"size-5"} />
                                <span>{device.dnsname}</span>
                            </Button>
                            <Button
                                plain
                                onClick={async () => {
                                    await ApiInternal.subnets.removeRouter(subnet.uuid, device.uuid);
                                    reset();
                                }}
                            >
                                <XCircleIcon />
                            </Button>
                        </div>
                    ))}
            </div>

            {routers_available.length !== 0 && (
                <>
                    <Subheading className={"mt-7 mb-2"}>{t("heading.available-routers")}</Subheading>
                    <div className={"flex flex-col gap-1"}>
                        {routers_available.map(({ device }) => (
                            <div className={"flex max-w-md gap-1"}>
                                <Button
                                    outline
                                    className={"grow justify-start!"}
                                    href={"/a/devices/$deviceId/general"}
                                    params={{ deviceId: device.uuid }}
                                >
                                    <ServerStackIcon className={"size-5"} />
                                    <span>{device.dnsname}</span>
                                </Button>
                                <Button
                                    plain
                                    onClick={async () => {
                                        await ApiInternal.subnets.addRouter(subnet.uuid, device.uuid);
                                        reset();
                                    }}
                                >
                                    <CheckCircleIcon />
                                </Button>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </>
    );
}
